import React from 'react'
import Grid from '@material-ui/core/Grid';


const MTow = (props) => {

    let { selectedFlightInfo } = props

    return (
        <div className="mtowInfo">
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <label>MTOW Number</label>
                    <div>{selectedFlightInfo.MTOWOutbound}</div>
                </Grid>
                <Grid item xs={6}>
                    <label>Potential Tow Number</label>
                    <div>{selectedFlightInfo.TOWOutbound}</div>
                </Grid>
            </Grid>
        </div>
    )
}

export default MTow